import {createMachine, propsChangedEvent, type Machine, type MachineScope} from '../../runtime/state-machine';
import type {FieldRuntimeProps} from './contract';

type FieldContext = Record<string, never>;
type FieldEffects = {sync(scope: MachineScope<FieldContext, FieldRuntimeProps>): void};
const fieldHooks = [] as const;
const nextInvalidIs = (invalid: boolean) => ({event}: MachineScope<FieldContext, FieldRuntimeProps>): boolean => (
    propsChangedEvent<FieldRuntimeProps>(event)?.props.invalid === invalid
);
const reconcileProps = (scope: MachineScope<FieldContext, FieldRuntimeProps>) => {
    const next = propsChangedEvent<FieldRuntimeProps>(scope.event)?.props;
    return next ? {props: next} : undefined;
};

const createFieldMachine = ({props, effects}: {props: FieldRuntimeProps; effects: FieldEffects}): Machine<FieldContext, FieldRuntimeProps> => createMachine<FieldContext, FieldRuntimeProps>({
    initial: props.invalid ? 'invalid' : 'valid',
    on: {
        PROPS_CHANGED: [
            {target: 'invalid', guard: nextInvalidIs(true), reduce: 'reconcileProps', effects: 'sync'},
            {target: 'valid', guard: nextInvalidIs(false), reduce: 'reconcileProps', effects: 'sync'},
        ],
        CONTENT_CHANGED: {effects: 'sync'},
    },
    states: {valid: {tags: ['valid']}, invalid: {tags: ['invalid']}},
}, {context: {}, props, reducers: {reconcileProps}, effects});

export {createFieldMachine, fieldHooks};
export type {FieldContext, FieldEffects};
